module.exports = __webpack_public_path__ + "media/assets/images/flags/li-c351357f3dde29df4452972fc56cb5af.svg";